"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rate = void 0;
var _react = _interopRequireDefault(require("react"));
var _rate = _interopRequireDefault(require("antd/es/rate"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = require("../Icons");
require("./style.sass");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Rate = function Rate(props) {
  var mainClassname = (0, _classnames.default)('sber-rate', props.className);
  return /*#__PURE__*/_react.default.createElement(_rate.default, _extends({}, props, {
    className: mainClassname,
    character: /*#__PURE__*/_react.default.createElement(_Icons.StarIcon, {
      color: "#333F48",
      size: 20
    })
  }));
};
exports.Rate = Rate;